function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { toLocaleString } from "./asc-tools";
/**
 * @deprecated use parseNumber instead
 * @param value
 */
export function numeral(value) {
  value = '' + value;
  var isNegative = value.startsWith('-');
  value = value.replace(/[^\d.,]/g, '');
  var digit,
    split = /^[\d.]+$/.test(value) ? ',' : /^[\d,]+$/.test(value) ? '.' : void 0,
    rightNumber = '';
  for (var i = 0; i < value.length; i++) {
    var char = value[i];
    if (char === '.' || char === ',') {
      if (split === void 0) {
        split = char;
      }
      if (split === '.') {
        digit = ',';
      } else if (split === ',') {
        digit = '.';
      }
      if (char === digit) {
        rightNumber += '.';
      }
    } else {
      rightNumber += char;
    }
  }
  var isValid = rightNumber.split('.').length <= 2;
  if (!isValid) {
    var number = value.replace(/[^\d]/g, '');
    return Number(number) * (isNegative ? -1 : 1);
  }
  return Number(rightNumber) * (isNegative ? -1 : 1);
}

/**
 * 根据已经格式化的数字，返回数字
 * @param value
 * @param options
 * @return {number}
 */
export function parseNumber(value, options) {
  var _ref = options || getNumberThousandsSeparator('SG'),
    thousandsSeparator = _ref.thousandsSeparator,
    radix = _ref.radix;
  value = '' + value;
  var isNegative = value.startsWith('-');
  value = value.replace(new RegExp("[^\\d".concat(radix, "]"), 'g'), '');
  var rightNumber = radix !== '.' ? value.replace(new RegExp("[".concat(radix, "]"), 'g'), '.') : value;
  var isValid = rightNumber.split('.').length <= 2;
  if (!isValid) {
    // remove all the dot without the first one
    var number = rightNumber.replace(new RegExp("(\\d\\.)(.+)"), function (d, firstPart, match) {
      return firstPart + match.replace(new RegExp("[.]", 'g'), '');
    });
    return Number(number) * (isNegative ? -1 : 1);
  }
  return Number(rightNumber) * (isNegative ? -1 : 1);
}
/**
 * @desc 解决浮动运算问题，避免小数点后产生多位数和计算精度损失。
 * 问题示例：2.3 + 2.4 = 4.699999999999999，1.0 - 0.9 = 0.09999999999999998
 */

/**
 * 把错误的数据转正
 * strip(0.09999999999999998)=0.1
 */
export function strip(num) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
  return +parseFloat(Number(num).toPrecision(precision));
}

/**
 * Return digits length of a number
 * @param {*number} num Input number
 */
export function digitLength(num) {
  // Get digit length of e
  var eSplit = num.toString().split(/[eE]/);
  var len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0);
  return len > 0 ? len : 0;
}

/**
 * 把小数转成整数，支持科学计数法。如果是小数则放大成整数
 * @param {*number} num 输入数
 */
export function float2Fixed(num) {
  if (num.toString().indexOf('e') === -1) {
    return Number(num.toString().replace('.', ''));
  }
  var dLen = digitLength(num);
  return dLen > 0 ? strip(Number(num) * Math.pow(10, dLen)) : Number(num);
}

/**
 * 检测数字是否越界，如果越界给出提示
 * @param {*number} num 输入数
 */
export function checkBoundary(num) {
  if (_boundaryCheckingState) {
    if (num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER) {
      console.warn("".concat(num, " is beyond boundary when transfer to integer, the results may not be accurate"));
    }
  }
}

/**
 * 迭代操作
 */
export function iteratorOperation(arr, operation) {
  var _arr = _toArray(arr),
    num1 = _arr[0],
    num2 = _arr[1],
    others = _arr.slice(2);
  var res = operation(num1, num2);
  others.forEach(function (num) {
    res = operation(res, num);
  });
  return res;
}

/**
 * 精确乘法
 */
export function times() {
  for (var _len = arguments.length, nums = new Array(_len), _key = 0; _key < _len; _key++) {
    nums[_key] = arguments[_key];
  }
  if (nums.length > 2) {
    return iteratorOperation(nums, times);
  }
  var num1 = nums[0],
    num2 = nums[1];
  var num1Changed = float2Fixed(num1);
  var num2Changed = float2Fixed(num2);
  var baseNum = digitLength(num1) + digitLength(num2);
  var leftValue = num1Changed * num2Changed;
  checkBoundary(leftValue);
  return leftValue / Math.pow(10, baseNum);
}

/**
 * 精确加法
 */
export function plus() {
  for (var _len2 = arguments.length, nums = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    nums[_key2] = arguments[_key2];
  }
  if (nums.length > 2) {
    return iteratorOperation(nums, plus);
  }
  var num1 = nums[0],
    num2 = nums[1];
  // 取最大的小数位
  var baseNum = Math.pow(10, Math.max(digitLength(num1), digitLength(num2)));
  // 把小数都转为整数然后再计算
  return (times(num1, baseNum) + times(num2, baseNum)) / baseNum;
}

/**
 * 精确减法
 */
export function minus() {
  for (var _len3 = arguments.length, nums = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    nums[_key3] = arguments[_key3];
  }
  if (nums.length > 2) {
    return iteratorOperation(nums, minus);
  }
  var num1 = nums[0],
    num2 = nums[1];
  var baseNum = Math.pow(10, Math.max(digitLength(num1), digitLength(num2)));
  return (times(num1, baseNum) - times(num2, baseNum)) / baseNum;
}

/**
 * 精确除法
 */
export function divide() {
  for (var _len4 = arguments.length, nums = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    nums[_key4] = arguments[_key4];
  }
  if (nums.length > 2) {
    return iteratorOperation(nums, divide);
  }
  var num1 = nums[0],
    num2 = nums[1];
  var num1Changed = float2Fixed(num1);
  var num2Changed = float2Fixed(num2);
  checkBoundary(num1Changed);
  checkBoundary(num2Changed);
  // fix: 类似 10 ** -4 为 0.00009999999999999999，strip 修正
  return times(num1Changed / num2Changed, strip(Math.pow(10, digitLength(num2) - digitLength(num1))));
}

/**
 * 四舍五入
 */
export function round(num, ratio) {
  var base = Math.pow(10, ratio);
  var result = divide(Math.round(Math.abs(times(num, base))), base);
  // @ts-ignore
  if (num < 0 && result !== 0) {
    result = times(result, -1);
  }
  return result;
}
var _boundaryCheckingState = true;

/**
 * 是否进行边界检查，默认开启
 * @param flag 标记开关，true 为开启，false 为关闭，默认为 true
 */
export function enableBoundaryChecking() {
  var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  _boundaryCheckingState = flag;
}

/**
 * 裁剪小数，非四舍五入
 * @param num
 * @param n
 */
export var cutDecimal = function cutDecimal(num, n) {
  var tempNum = num;
  for (var i = 0; i < n; i++) {
    // Bad Case: 66888.9 * 10 * 10 !== 66888.9 * 100
    tempNum = strip(tempNum * 10);
  }
  return Math.floor(tempNum) / Math.pow(10, n);
};

/**
 * 精确计算合集，避免浮点数误差
 */
export var NumeralMath = {
  times: times,
  plus: plus,
  minus: minus,
  divide: divide,
  round: round,
  cutDecimal: cutDecimal
};

// @ts-ignore
var thousandsSeparatorCache = {};
export function getNumberThousandsSeparator(countryCode, options) {
  if (thousandsSeparatorCache[countryCode]) {
    return thousandsSeparatorCache[countryCode];
  }
  var number = 11111.123;
  var formatted = toLocaleString(number, _objectSpread(_objectSpread({}, options), {}, {
    countryCode: countryCode
  }));
  var result = {
    thousandsSeparator: formatted[2],
    radix: formatted[6]
  };
  thousandsSeparatorCache[countryCode] = result;
  return result;
}